import React from 'react'
import AloModal from '../AloModal'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import './FilterUniButtonModal.scss'

const FilterUniButtonModal = ({
  options,
  currentlySelectedOption,
  onSelect,
  ...rest
}) => {
  return (
    <AloModal {...rest} className='FilterUniButtonModal'>
      <Modal.Body>
        {options.map((option, idx) => {
          let modalItemClass = 'FilterUniButtonModal__item'
          if (
            currentlySelectedOption === (option.filterValue || option.label)
          ) {
            modalItemClass += ' FilterUniButtonModal__item--active'
          }
          return (
            <div
              className={modalItemClass}
              key={idx}
              onClick={() => {
                onSelect(option)
                rest.onHide()
              }}
            >
              {option.label}
            </div>
          )
        })}
      </Modal.Body>
    </AloModal>
  )
}

FilterUniButtonModal.propTypes = {
  options: PropTypes.array,
  currentlySelectedOption: PropTypes.string,
  onSelect: PropTypes.func,
  onHide: PropTypes.func
}

export default FilterUniButtonModal
